// extracted by mini-css-extract-plugin
module.exports = {"item":"ProposalItem_item__21lpC"};